<div class="tabs">

  @if(slider){

  <owl-carousel-o [options]="customOptions" #owlElement>
    <ng-container *ngFor="let tab of tabList; let i = index">
      <ng-template carouselSlide *ngIf="tab?.condition">

        <div class="slider-tab" [ngClass]="{ active: defaultTabIndex == i }" (click)="selectTab(i)">
          @if(tab.icon){
          <i [class]="tab.icon"></i>
          }
          {{ tab.title }}
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>


  }@else if(tabList?.length > 0 ) {

  <div class="tabs__header {{ size }} design-{{ design }}">
    <ng-container *ngFor="let tab of tabList; let i = index">
      <div class="tabs__header--item" [ngClass]="{ active: defaultTabIndex === i }" (click)="selectTab(i)"
        *ngIf="tab?.condition">
        @if(tab.icon){
        <i [class]="tab.icon"></i>
        }
        {{ tab.title}}
        <!-- {{ tab.title.includes('Experiences')?'Experiences (' + commonService.countOfExperiences + ')' :} -->
      </div>
    </ng-container>
  </div>

  }

  <div class="tabs__content">
    <div class="tabs__content--body">
      <ng-container *ngIf="defaultTabIndex == 0">
        <ng-content select="[tab0]"></ng-content>
      </ng-container>
      <ng-container *ngIf="defaultTabIndex == 1">
        <ng-content select="[tab1]"></ng-content>
      </ng-container>
      <ng-container *ngIf="defaultTabIndex == 2">
        <ng-content select="[tab2]"></ng-content>
      </ng-container>
      <ng-container *ngIf="defaultTabIndex == 3">
        <ng-content select="[tab3]"></ng-content>
      </ng-container>
      <ng-container *ngIf="defaultTabIndex == 4">
        <ng-content select="[tab4]"></ng-content>
      </ng-container>
      <ng-container *ngIf="defaultTabIndex == 5">
        <ng-content select="[tab5]"></ng-content>
      </ng-container>
      <ng-container *ngIf="defaultTabIndex == 6">
        <ng-content select="[tab6]"></ng-content>
      </ng-container>
      <ng-content select="[allTab]"></ng-content>
    </div>
  </div>
</div>